'use client'

import React from 'react'
import Image from 'next/image'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'hero'
  variant?: 'icon' | 'full'
  className?: string
}

// Logo aspect ratio is ~3:1 (512x173)
const sizeMap = {
  sm: { h: 24, w: 71 },
  md: { h: 32, w: 95 },
  lg: { h: 44, w: 130 },
  xl: { h: 56, w: 166 },
  xxl: { h: 72, w: 213 },
  hero: { h: 96, w: 284 },
} as const

export function Logo({ size = 'md', className = '' }: LogoProps) {
  const { h, w } = sizeMap[size]

  return (
    <div className={`flex items-center ${className}`}>
      {/* Dark logo (black text) — visible in light mode, hidden in dark mode */}
      <Image
        src="/images/hitoo_dark.png"
        alt="Hitoo"
        width={w}
        height={h}
        className="dark:hidden"
        priority
      />
      {/* White logo — hidden in light mode, visible in dark mode */}
      <Image
        src="/images/hitoo_white.png"
        alt="Hitoo"
        width={w}
        height={h}
        className="hidden dark:block"
        priority
      />
    </div>
  )
}